import TicketMap from '../../pages/ticketMap/TicketMap.js';
import Modal from 'react-bootstrap/Modal';

export default function ModalMap({data , show , setShow}) {

    if( !data ) {
        return 
    }

    const newData = { body:[ data ]};
  return (
    <Modal show={show} size='xl' onHide={() => setShow(false)} >
        <Modal.Header closeButton>
        <Modal.Title>Segnalazione #{newData.body[0].id}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <TicketMap data={ newData } options={{}} disablePopup={true} />
        </Modal.Body>

    </Modal>
  );
}